var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"np-module-container"},[_c('split-panel',[_c('div',{attrs:{"slot":"left-pane"},slot:"left-pane"},[_c('side-navigation')],1),_c('div',{attrs:{"slot":"right-pane"},slot:"right-pane"},[_c('router-view',{staticClass:"view"})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }